import { co2AvoidedIcon2, downloadLightIcon, moonIcon, sunIcon, treenPlantedIcon } from "assets/icons";
import { Select } from "components/form";
import React, { useEffect, useState } from "react";
import AreaChartReport from "./section/AreaChart";
import "./Report.scss";
import CustomDonutChart from "./section/DonutChart";
import DGParameters from "./section/DGParameters";
import SolarConsumption from "./section/SolarConsumption";
import { getReportDataApi } from "services/dashboard";
import { failMessage } from "utils/toastMessage";
import { useSelector } from "react-redux";
import { customDay } from "utils/dropdownValue/selectBoxValue";
import { formatTimeTo12Hour, getBeforeDecimalValue } from "utils/commonFun";
import { useParams } from "react-router-dom";
import DateFilter from "./section/DateFilter";
import { getDownloadReport } from "pages/report/downloadReport";
import Spinners from "loader/Spinners";
const Report = () => {
  const { selectedSite } = useSelector((state) => (state?.selectedSite))
  const [selectedDay, setSelectedDay] = useState(customDay[0]?.id);
  const [loader, setLoader] = useState(false)
  const [loading, setLoading] = useState(false)
  const [dateModal, setDateModal] = useState(false)
  const [customDate, setCustomDate] = useState({ from: '', to: '' })
  const [localCustomDate, setLocalCustomDate] = useState({ from: '', to: '' })
  const { graphData } = useParams(); // e.g. "solar", "dg", etc.
  const [reportData, setReportData] = useState({
    dgParameters: {},
    environment: {},
    graph: [],
    powerConsumptionPie: {},
    totalStats: {},
  });

  // -------select-filter-value---------
  let filterDay = customDay?.find(data => data.id === selectedDay);
  const isDate = !(selectedDay === 'custom' && (!localCustomDate.from || !localCustomDate.to));

  // ----------handle-Change---------------
  const handleChange = (e) => {
    setSelectedDay(e.target.value);
    setCustomDate({ from: '', to: '' })
    setLocalCustomDate({ from: '', to: '' })
  };
  //--------get-Report-Data-listing-------------
  const getReportData = async () => {
    if (selectedSite?._id) {
      setLoader(true)
      setReportData({})
      try {
        const params = {
          plantId: selectedSite?._id,
          ...(customDate.from && customDate.to
            ? {
              range: 'custom',
              from: customDate.from,
              to: customDate.to,
            }
            : {
              range: selectedDay,
            }),
        };
        const res = await getReportDataApi(params)
        if (res?.status === 200) {
          const data = res?.data?.reports
          setReportData(data || {})
        } else {
          failMessage(res)
          setReportData({})
        }
      } catch (e) {
        console.log('error', e?.message)
      } finally {
        setLoader(false)
      }
    }
  }
  useEffect(() => {
    if (selectedDay !== 'custom' || customDate.from && customDate.to) {
      getReportData();
    }
  }, [selectedDay, customDate.from, customDate.to, selectedSite?._id,])


  const handleCustomDate = () => {
    setDateModal(true)
    setSelectedDay("custom");
  }
  return (
    <>
      <div className="container">
        <div className="report_wrap">
          <div className="mode_button">
            <div className="button_wrap">
              <button type="button" className="button sun">
                <img src={sunIcon} alt="" />
                <p>
                  <span>Start Time</span>
                  <b>{formatTimeTo12Hour(reportData?.plantStart)}</b>
                </p>
              </button>
              <button type="button" className="button moon">
                <img src={moonIcon} alt="" />
                <p>
                  <span>Stop Time</span>
                  <b>{formatTimeTo12Hour(reportData?.plantEnd)}</b>
                </p>
              </button>
            </div>
            {selectedDay === 'custom' &&
              <DateFilter
                setCustomDate={setCustomDate}
                customDate={customDate}
                localCustomDate={localCustomDate}
                setLocalCustomDate={setLocalCustomDate}
              />
            }
            <div className="section_wrap">
              <button disabled={loading || !isDate} onClick={() => getDownloadReport(selectedSite, setLoading, localCustomDate, selectedDay)} type="button" className="download_button">
                {loading ? <Spinners /> :
                  <img src={downloadLightIcon} alt="" />}
              </button>

              <Select
                name="subject"
                value={selectedDay}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "custom") {
                    handleCustomDate(); // open modal
                  } else {
                    handleChange(e);    // normal selection
                  }
                }}
              >
                {customDay && customDay.length > 0 ? (
                  customDay.map(({ id, value }) => (
                    <option key={id} value={id}>
                      {value}
                    </option>
                  ))
                ) : (
                  <option disabled>No subjects available</option>
                )}
                <option value="custom">Custom date</option>
              </Select>
            </div>
          </div>


          <div className="card_wrap">
            {/* ----------area-chart---------------- */}
            <div className="_card">
              <AreaChartReport {...{ graph: reportData?.graph, selectedDay, customDate, filterDay, graphData, loader }} />
            </div>
            {/* ----------Solar-Consumption---------------- */}
            <SolarConsumption {...{ SolarConsumptionData: reportData?.totalStats, graphData }} />
            {/* ----------DG-Parameter---------------- */}
            <DGParameters {...{ DGParametersData: reportData?.dgParameters }} />
            {/* ----------Donut-Chart---------------- */}
            <div className="_card">
              <CustomDonutChart {...{ powerConsumptionPie: reportData?.powerConsumptionPie }} />
            </div>

            <div className="_card environmental_parameters">
              <h5>Environmental Parameters</h5>
              <ul>
                <li>
                  <img src={treenPlantedIcon} alt="" />
                  <p>
                    <small>Tree Planted</small>
                    <b>{getBeforeDecimalValue(reportData?.environment?.treePlanted)}</b>
                  </p>
                </li>
                <li>
                  <img src={co2AvoidedIcon2} alt="" />
                  <p>
                    <small>Co2 Avoided</small>
                    <b>{reportData?.environment?.co2Avoided || '0'} MT</b>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Report;